
<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title [matTooltip]="amazondata.summaries[0].itemName">{{amazondata.summaries[0].itemName}} </mat-card-title>
        <mat-card-subtitle>ASIN: {{amazondata.asin}}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="content">
            <div class="foto" *ngIf="!hideImage">
                <carousel arrowsOutside="true" dots="false" cellsToShow="1" cellWidth="100"  height="120" width="120">
                    <div class="carousel-cell" *ngFor="let image of amazondata.images[0].images"> 
                        <img [src]="image.link">
                    </div>
                </carousel>
            </div>
            <div class="dados" *ngIf="hideImage">
                <!--div class="title">
                    {{amazondata.summaries[0].itemName}}
                </div-->
                <div class="sumario">
                    <ul class="left">
                        <li><b>Marca:</b> {{amazondata.summaries[0].brandName}}</li>
                        <li><b>Cor:</b> {{amazondata.summaries[0].itemName}}</li>
                        <li><b>Fabricante:</b> {{amazondata.summaries[0].manufacturer}}</li>
                    </ul>
                    <ul class="right">
                        <li *ngFor="let id of amazondata.identifiers[0].identifiers">
                            <b>{{id.identifierType}}:</b> {{id.identifier}};
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <span class="link-more" (click)="clickInfo()">{{textInformacoes}} informações</span>
        <div fxFlex></div>
        <button mat-raised-button color="accent" (click)="selectData()">Vender</button>
      </mat-card-actions>
</mat-card>

